import { PartiuClient } from "@partiu-vantagens/partiu-sdk";
import axios from "axios";

console.log(process.env.REACT_APP_API_URL);
let baseUrl = `${process.env.REACT_APP_API_URL}/api/v1`;

export const axiosInstance = axios.create({
  baseURL: baseUrl,
  validateStatus: (status) => {
    if (status === 401) {
      setAccessToken(null);
      localStorage.removeItem("token");
      window.location.reload();
    }
    return status >= 200 && status < 400;
  },
});

export const axiosInstanceV2 = axios.create({
  baseURL: baseUrl.replace("v1", "v2"),
  validateStatus: (status) => {
    if (status === 401) {
      setAccessToken(null);
      localStorage.removeItem("token");
      window.location.reload();
    }
    return status >= 200 && status < 400;
  },
});

export const partiuClient = new PartiuClient(
  process.env.REACT_APP_API_URL?.indexOf("staging") !== -1
);

export const setAccessToken = (token: string | null) => {
  if (token == null) partiuClient.auth.logout();
  else partiuClient.auth.login(token);

  if (token == null)
    axiosInstance.defaults.headers.common["Authorization"] = null;
  else
    axiosInstance.defaults.headers.common["Authorization"] = `TOKEN ${token}`;

  if (token == null)
    axiosInstanceV2.defaults.headers.common["Authorization"] = null;
  else
    axiosInstanceV2.defaults.headers.common["Authorization"] = `TOKEN ${token}`;
};
